var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUptime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_6001_4294)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6001_4294)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6001_4294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.334 18.3899C10.5956 18.0675 9.99887 17.4886 9.65427 16.7603C9.30967 16.0319 9.2405 15.2034 9.45956 14.428C9.67862 13.6526 10.1711 12.9828 10.8459 12.5424C11.5206 12.102 12.332 11.9209 13.13 12.0326C13.3713 11.1455 13.9369 10.3815 14.7149 9.89175C15.4928 9.40203 16.4264 9.2224 17.3305 9.38845C18.2347 9.5545 19.0435 10.0541 19.5967 10.7883C20.1498 11.5225 20.4071 12.4377 20.3174 13.3526C20.9051 13.4226 21.4529 13.6861 21.8744 14.1016C22.2959 14.5172 22.5672 15.0612 22.6455 15.6479C22.7238 16.2346 22.6046 16.8306 22.3068 17.3422C22.0091 17.8537 21.5495 18.2516 21.0007 18.4733",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 18.668L15 16.668V22.668",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.668 15.332V21.332L19.668 19.332",
    stroke: "white",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6001_4294",
    x1: 0,
    y1: 0,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA5A00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6001_4294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6001_4294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptime);
export default __webpack_public_path__ + "static/media/uptime.50b45c32c454372e58bdf4a4c3405a5e.svg";
export { ForwardRef as ReactComponent };